<template>
	<transition-group tag="div" name="notification" class="notifications">
		
		<div v-for="notification in game.notifications" :key="notification.id" class="notification">
			<div class="notification-content">
				<div class="notification-text">
					<icon file="info" :size="34" />
					<p>{{ notification.text }}</p>
				</div>
			</div>
		</div>

	</transition-group>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Notifications',
	data: function() {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'game' ]), {

	})
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.notifications
	position fixed
	right 16px
	top 16px
	width 320px
	font-family 'Averia Libre'
	.notification
		display block
		margin 0 0 8px 0
		text-align right
		&.notification-enter-active, &.notification-leave-active, &.notification-move
			transition 0.15s easeOutQuart
		&.notification-enter, &.notification-leave-to
			opacity 0
			transform translate3D(100%, 0, 0)
		.notification-content
			display inline-block
			background lighten(lightblue, 75%)
			box-shadow 1px 2px 0 0 lighten(dark, 50%)
			text-align left
			border-radius 8px
			padding 14px 16px 16px 16px
			.notification-text
				font-size 16px
				line-height 18px
				display flex
				align-items center
				padding-left 48px
				// justify-content flex-start
				.icon
					position absolute
					left 0
					top calc(50% - 16px)
					width 32px
					height 32px
					margin 0 8px 0 0
			
			// display flex
		
</style>



// WEBPACK FOOTER //
// src/components/ui/Notifications.vue